var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useGetAllMenuQuery, useGetDashletsPreferencesUserQuery, useSaveDashletPreferencesMutation, useSearchDashletChartMutation, } from "@/store/api";
import { useEffect, useMemo, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPen, faRotateLeft } from "@fortawesome/pro-solid-svg-icons";
import { LoaderImage } from "@/utils/loader";
import EditChart from "./editChart";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import Chart from "./chart";
export default function WidgetChart(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var widget = _a.widget, onChange = _a.onChange;
    var searchDashletChart = useSearchDashletChartMutation()[0];
    var _m = useGetDashletsPreferencesUserQuery({}), preferenceDashlet = _m.data, loadGetDashlet = _m.isLoading;
    var rootStyles = getComputedStyle(document.documentElement);
    var labelColor = rootStyles.getPropertyValue("--colors-label").trim();
    var bgColor = rootStyles.getPropertyValue("--colors-body-bg-sec").trim();
    var _o = useState(false), isPopupOpen = _o[0], setIsPopupOpen = _o[1];
    var chartData = ((_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.chartData) || [];
    var t = useTranslation(["common", "Charts"]).t;
    var colors = ((_d = (_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.chartData) === null || _d === void 0 ? void 0 : _d.colors) || [];
    var _p = useState(""), title = _p[0], seTtitle = _p[1];
    console.log("widget", widget === null || widget === void 0 ? void 0 : widget.payload);
    var rowId = (widget === null || widget === void 0 ? void 0 : widget.rowId) || "";
    var _q = useState(widget === null || widget === void 0 ? void 0 : widget.rowMeta), rowMeta = _q[0], setRowMeta = _q[1];
    var _r = useState((widget === null || widget === void 0 ? void 0 : widget.payload.allDashlets) || []), allDashlets = _r[0], setAllDashlets = _r[1];
    useEffect(function () {
        if (widget === null || widget === void 0 ? void 0 : widget.payload.allDashlets) {
            setAllDashlets(widget.payload.allDashlets);
        }
    }, [widget === null || widget === void 0 ? void 0 : widget.payload.allDashlets]);
    var dashlets = (widget === null || widget === void 0 ? void 0 : widget.payload.dashlets) || [];
    var id = (widget === null || widget === void 0 ? void 0 : widget.payload.id) || "";
    var _s = useState(false), reinitialize = _s[0], setReinitialize = _s[1];
    var chartRef = useRef(null);
    var _t = useState(((_e = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _e === void 0 ? void 0 : _e.chartType) || "pie"), chartType = _t[0], setChartType = _t[1];
    var findRowById = function (data, id) {
        for (var key in data) {
            var row = data[key].meta.find(function (item) { return item.id === id; });
            if (row) {
                return data[key];
            }
        }
        return null;
    };
    var rowDb = (((_f = preferenceDashlet === null || preferenceDashlet === void 0 ? void 0 : preferenceDashlet.data) === null || _f === void 0 ? void 0 : _f.dashlets) &&
        ((_h = findRowById((_g = preferenceDashlet === null || preferenceDashlet === void 0 ? void 0 : preferenceDashlet.data) === null || _g === void 0 ? void 0 : _g.dashlets, id)) === null || _h === void 0 ? void 0 : _h.meta)) ||
        [];
    useEffect(function () {
        var _a, _b;
        if ((widget === null || widget === void 0 ? void 0 : widget.payload.value) === "kpi") {
            setChartType((_a = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _a === void 0 ? void 0 : _a.chartType);
        }
        seTtitle((_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.title);
        /*seTtitle(
          rowDb.find((item: any) => item.id === id)?.chartData?.lang_en?.LBL_TITLE
        );*/
    }, [preferenceDashlet, widget]);
    var currentRow = rowDb === null || rowDb === void 0 ? void 0 : rowDb.find(function (row) { return row.id === id; });
    var currentRowConfig = (currentRow === null || currentRow === void 0 ? void 0 : currentRow.searchedData)
        ? currentRow === null || currentRow === void 0 ? void 0 : currentRow.searchedData
        : {};
    var currentSearchfields = (_k = (_j = currentRow === null || currentRow === void 0 ? void 0 : currentRow.chartData) === null || _j === void 0 ? void 0 : _j.searchFields) !== null && _k !== void 0 ? _k : null;
    var appLists = t("app_lists");
    var leadSourceDom = (appLists === null || appLists === void 0 ? void 0 : appLists.lead_source_dom) || {};
    var sales_stage_dom = (appLists === null || appLists === void 0 ? void 0 : appLists.sales_stage_dom) || {};
    var options = {
        users: Object.keys(((_l = currentRow === null || currentRow === void 0 ? void 0 : currentRow.chartData) === null || _l === void 0 ? void 0 : _l.users) || {}),
        leadSources: Object.keys(leadSourceDom || {}),
        salesStages: Object.keys(sales_stage_dom || {}),
    };
    var searchDashlet = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestData, result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestData = {};
                    currentSearchfields &&
                        requestData &&
                        Object.entries(currentSearchfields).forEach(function (_a) {
                            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                            var key = _a[0], field = _a[1];
                            switch (key) {
                                case "obm_ids":
                                    requestData.obm_ids =
                                        ((_b = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.selectedOptions) === null || _b === void 0 ? void 0 : _b.users) || options.users;
                                    requestData.obm_date_start =
                                        ((_c = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange) === null || _c === void 0 ? void 0 : _c.obm_date_start) || "";
                                    requestData.obm_date_end =
                                        ((_d = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange) === null || _d === void 0 ? void 0 : _d.obm_date_end) || "";
                                    break;
                                case "lsbo_lead_sources":
                                    requestData.lsbo_ids =
                                        ((_e = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.selectedOptions) === null || _e === void 0 ? void 0 : _e.users) || options.users;
                                    requestData.lsbo_lead_sources =
                                        ((_f = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.selectedOptions) === null || _f === void 0 ? void 0 : _f.leadSources) ||
                                            options.leadSources;
                                    break;
                                case "pbls_ids":
                                    requestData.pbls_ids =
                                        ((_g = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.selectedOptions) === null || _g === void 0 ? void 0 : _g.users) || options.users;
                                    requestData.pbls_lead_sources =
                                        ((_h = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.selectedOptions) === null || _h === void 0 ? void 0 : _h.leadSources) ||
                                            options.leadSources;
                                    break;
                                case "pbss_sales_stages":
                                    requestData.pbss_sales_stages =
                                        ((_j = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.selectedOptions) === null || _j === void 0 ? void 0 : _j.salesStages) ||
                                            options.salesStages;
                                    requestData.pbss_date_start =
                                        ((_k = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange) === null || _k === void 0 ? void 0 : _k.pbss_date_start) || "";
                                    requestData.pbss_date_end =
                                        ((_l = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange) === null || _l === void 0 ? void 0 : _l.pbss_date_end) || "";
                                    break;
                                case "mypbss_sales_stages":
                                    requestData.mypbss_sales_stages =
                                        ((_m = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.selectedOptions) === null || _m === void 0 ? void 0 : _m.salesStages) ||
                                            options.salesStages;
                                    requestData.mypbss_date_start =
                                        ((_o = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange) === null || _o === void 0 ? void 0 : _o.mypbss_date_start) || "";
                                    requestData.mypbss_date_end =
                                        ((_p = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange) === null || _p === void 0 ? void 0 : _p.mypbss_date_end) || "";
                                    break;
                                default:
                                    break;
                            }
                        });
                    Object.keys(requestData).forEach(function (key) {
                        if (requestData[key] === "Unknown") {
                            requestData[key] = "";
                        }
                        else if (Array.isArray(requestData[key])) {
                            requestData[key] = requestData[key].map(function (v) {
                                return v === "Unknown" ? "" : v;
                            });
                        }
                    });
                    console.log("search", requestData);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, searchDashletChart({ body: requestData }).unwrap()];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, result];
                case 3:
                    err_1 = _a.sent();
                    console.error("Error searching dashlet chart:", err_1);
                    throw err_1;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getSearchedDashlet = function () { return __awaiter(_this, void 0, void 0, function () {
        var resultSearch, newChartData, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, searchDashlet()];
                case 1:
                    resultSearch = _b.sent();
                    newChartData = (_a = resultSearch === null || resultSearch === void 0 ? void 0 : resultSearch.data) === null || _a === void 0 ? void 0 : _a.dashlets;
                    return [2 /*return*/, newChartData];
                case 2:
                    error_1 = _b.sent();
                    console.error("Failed to fetch chart data:", error_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var refreshChart = function () { return __awaiter(_this, void 0, void 0, function () {
        var search_1, updatedDashlets_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getSearchedDashlet()];
                case 1:
                    search_1 = _a.sent();
                    if (search_1 &&
                        JSON.stringify(search_1) !== JSON.stringify(currentRow === null || currentRow === void 0 ? void 0 : currentRow.chartData)) {
                        updatedDashlets_1 = rowMeta.map(function (dashlet) {
                            return dashlet.id === id
                                ? __assign(__assign({}, dashlet), { chartData: __assign({}, search_1) }) : dashlet;
                        });
                        setAllDashlets(function (prevDashlets) {
                            var updatedDashletsState = __assign({}, prevDashlets);
                            for (var key in updatedDashletsState) {
                                if (updatedDashletsState[key].id === rowId) {
                                    updatedDashletsState[key] = __assign(__assign({}, updatedDashletsState[key]), { meta: updatedDashlets_1 });
                                    break;
                                }
                            }
                            updatedDashletsState &&
                                saveDashletPreferences({
                                    dashlets: updatedDashletsState,
                                    isNew: false,
                                })
                                    .unwrap()
                                    .then(function () {
                                    if (chartRef.current) {
                                        chartRef.current.getEchartsInstance();
                                    }
                                })
                                    .catch(function (error) {
                                    console.error("Failed to save dashlet preference:", error);
                                });
                        });
                    }
                    else {
                        toast.error("There is no update for this graph.");
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error("Error fetching searched dashlet:", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var _u = useSaveDashletPreferencesMutation(), saveDashletPreferences = _u[0], _v = _u[1], dashletLoad = _v.isLoading, isError = _v.isError, data = _v.data;
    var removeClick = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var currentDashlet, newDashlets, result, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentDashlet = Object.values(widget === null || widget === void 0 ? void 0 : widget.rowMeta).filter(function (item) {
                        return item.id !== id;
                    });
                    newDashlets = Object.values(allDashlets).map(function (row) {
                        if (row.id === widget.rowId) {
                            return __assign(__assign({}, row), { meta: currentDashlet });
                        }
                        else {
                            return row;
                        }
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce dashlet ?")) return [3 /*break*/, 3];
                    return [4 /*yield*/, saveDashletPreferences({
                            dashlets: newDashlets,
                            isNew: false,
                        }).unwrap()];
                case 2:
                    result = _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_3 = _a.sent();
                    console.error("Failed to save widgets:", error_3);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var editClick = function () {
        setIsPopupOpen(true);
    };
    var closePopup = function () {
        setIsPopupOpen(false);
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ id: "grid", className: "m-2 dark:bg-[var(--colors-bg-default)] p-2 rounded-md shadow sm:p-4 relative grid-container" }, { children: [dashletLoad && _jsx(LoaderImage, {}), _jsxs("div", __assign({ className: "border-b-2 mb-4 flex flex-row justify-between" }, { children: [_jsx("h3", __assign({ className: "uppercase font-bold my-2" }, { children: title })), _jsxs("div", __assign({ className: "flex flex-row justify-end" }, { children: [_jsx("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onClick: editClick, title: "Editer" }, { children: _jsx(FontAwesomeIcon, { icon: faPen, className: "text-gray-400" }) })), _jsx("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onClick: function () {
                                        setReinitialize(!reinitialize);
                                        refreshChart();
                                    }, title: "Retourner" }, { children: _jsx(FontAwesomeIcon, { icon: faRotateLeft, className: "text-gray-400" }) })), _jsx("button", __assign({ className: "hover:bg-red-500 p-1 rounded-md", onClick: removeClick, title: "Supprimer" }, { children: _jsx(FontAwesomeIcon, { icon: faClose, className: "text-gray-400 hover:text-white" }) }))] }))] })), _jsx(Chart, { chartData: chartData, chartType: chartType }), isPopupOpen && (_jsx(EditChart, { isOpen: isPopupOpen, onClose: function () { return setIsPopupOpen(false); }, title: title || "", records: widget, id: id }))] })) }));
}
function WidgetSettings(_a) {
    var widget = _a.widget, onChange = _a.onChange;
    var menuResponse = useGetAllMenuQuery(null).data;
    // Memo : all modules used for translation
    var allModules = useMemo(function () {
        var _a, _b, _c, _d;
        var value = ((_d = (_c = (_b = (_a = menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.data) === null || _a === void 0 ? void 0 : _a.main) === null || _b === void 0 ? void 0 : _b.tabs) === null || _c === void 0 ? void 0 : _c.LBL_TABGROUP_ALL) === null || _d === void 0 ? void 0 : _d.modules) || {};
        return Object.keys(value);
    }, [menuResponse]);
    return (_jsx("div", { children: _jsx("label", __assign({ htmlFor: "module-type-button", id: "module-type-label" }, { children: "Chart" })) }));
}
widgetsDictionary.register("widget/dashlet/chart", {
    name: "Widget Dashlet Chart",
    display: WidgetChart,
    settings: WidgetSettings,
    selectable: false,
});
